import { render, staticRenderFns } from "./label-select.vue?vue&type=template&id=5cc993cc&scoped=true&"
import script from "./label-select.vue?vue&type=script&lang=ts&"
export * from "./label-select.vue?vue&type=script&lang=ts&"
import style0 from "./label-select.vue?vue&type=style&index=0&id=5cc993cc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc993cc",
  null
  
)

export default component.exports